import React from 'react';
import { Button } from '@cargomatic/ui';
import { Map } from 'lucide-react';
/**
 * Toggle button for showing/hiding a map panel.
 *
 * Visually emphasizes the hidden state (`secondary` fill) so users
 * notice the available map; calms down once the map is visible (`outline`).
 */
export function MapToggleButton({ showMap, onClick, className, }) {
    return (React.createElement(Button, { variant: showMap ? 'outline' : 'secondary', size: "sm", className: className, onClick: onClick },
        React.createElement(Map, { className: "w-4 h-4 mr-1" }),
        showMap ? 'Hide Map' : 'Show Map'));
}
